(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/backgrounds/assets/react/skrapspel-background/skrapspel-background.js') >= 0) return;  svs.modules.push('/components/tur/backgrounds/assets/react/skrapspel-background/skrapspel-background.js');
"use strict";


const Bubbles = svs.components.tur.Bubbles;
const SkrapspelBackground = _ref => {
  let ticketType = _ref.ticketType;
  return React.createElement("div", {
    className: "backgrounds backgrounds-skrapspel ".concat(ticketType ? "bg-skrapspel-".concat(ticketType) : 'bg-skrapspel')
  }, React.createElement(Bubbles, {
    ticketType: ticketType
  }));
};
svs.components.tur.backgrounds.SkrapspelBackground = SkrapspelBackground;

 })(window);